import React from 'react';
import {ModalBody, Button} from 'reactstrap';
import Modal from 'components/Modal';
import OptInForm from 'components/OptInForm';
import ModalContext from 'contexts/modal';
import {usePhaseState} from 'funnel-schedule/phase-context';
import classNames from 'classnames';

export default function OptinModal({isEvergreen = true, ...props}) {
  return (
    <ModalContext.Consumer>
      {(modalProps) => (
        <Modal {...props} isOpen={modalProps.isOpen} toggle={modalProps.toggle} size="lg">
          <ModalBody className="px-lg-4 pt-0 pb-4">
            <OptInForm onComplete={modalProps.toggle} id="modalOptInForm" isEvergreen={isEvergreen} />
          </ModalBody>
        </Modal>
      )}
    </ModalContext.Consumer>
  );
}

export function OptinModalTrigger({isEvergreen = true, ...props}) {
  const {
    phases: {default: defaultSchedule = {phase: 'before'}}
  } = usePhaseState();

  return (
    <ModalContext.Consumer>
      {(modalProps) => {
        return (
          <Button
            color="cta"
            size="lg"
            {...props}
            className={classNames('btn-size-350 text-uppercase text-white text-condensed text-800', props.className)}
            onClick={modalProps.toggle}
          >
            Watch For Free Now
          </Button>
        );
      }}
    </ModalContext.Consumer>
  );
}
